import {
    DEALERGETTRANSACTIONMASTERLIST_SUCCESS,
    DEALERGETTRANSACTIONMASTERLIST_FAILED,
    RESET_DEALERGETTRANSACTIONMASTERLIST,
    LOADING_DEALERGETTRANSACTIONMASTERLIST,
    NETWORK_ERROR_DEALERGETTRANSACTIONMASTERLIST
} from '../types/index'
import { dealerServices } from "../../config/axios";

const resetDealerGetTransactionMasterList = () => {
    return { type: RESET_DEALERGETTRANSACTIONMASTERLIST };
};

const dealerGetTransactionMasterList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERGETTRANSACTIONMASTERLIST });
    await dealerServices
        .post("getTransactionMasterList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerGetTransactionMasterListsuccess(res.data));
                    break;
                default:
                    dispatch(dealerGetTransactioMasterListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERGETTRANSACTIONMASTERLIST,
                payload: err
            });
        });
}

function dealerGetTransactionMasterListsuccess(data) {
    return {
        type: DEALERGETTRANSACTIONMASTERLIST_SUCCESS,
        payload: data
    };
}

function dealerGetTransactioMasterListFailed(data) {
    return {
        type: DEALERGETTRANSACTIONMASTERLIST_FAILED,
        payload: data
    };
}

export { resetDealerGetTransactionMasterList, dealerGetTransactionMasterList }